// MarketplaceTab.js
import React, { useEffect, useMemo, useState } from 'react';
import { Row, Col, Card, Button, Typography, Space, Skeleton, Empty, Tag, Tooltip, Popconfirm, message } from 'antd';
import { PlusOutlined, InfoCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import axios from 'axios';
import NovoAnuncioMkt from './NovoAnuncioMkt';
import EditarAnuncioMkt from './EditarAnuncioMkt';
import { useConfigQuery } from '../../../../queries/useConfig';

const { Title, Text } = Typography;

const STATUS_MAP = {
    5: { label: 'Ativo', color: 'green' },
    9: { label: 'Rascunho', color: 'default' },
};

function parseStatusCode(code) {
    if (code === null || code === undefined) return undefined;
    const n = Number(code);
    return Number.isNaN(n) ? undefined : n;
}

function deriveStatus(item) {
    // 1) Se o item já for um anúncio (tem saleChannelStatus), use direto
    const top = parseStatusCode(item?.saleChannelStatus);
    if (top && STATUS_MAP[top]) return STATUS_MAP[top];

    // 2) Se for o produto com ads, procure o status mais recente entre eles
    const ads = Array.isArray(item?.ads) ? item.ads : [];
    const updates = [];

    for (const ad of ads) {
        // status atual do anúncio
        const s = parseStatusCode(ad?.saleChannelStatus);
        if (s) {
            const dateStr =
                ad?.updateDate || ad?.updatedAt || ad?.forsaledatestend || ad?.forsaledatestart;
            const d = dateStr ? new Date(dateStr) : new Date(0);
            updates.push({ date: isNaN(d) ? new Date(0) : d, status: s });
        }

        // histórico opcional (compatibilidade com formato antigo)
        const hist = ad?.saleChannelStatusUpdateDate || [];
        for (const u of hist) {
            const su = parseStatusCode(u?.saleChannelStatus);
            if (su) {
                const du = u?.updateDate ? new Date(u.updateDate) : new Date(0);
                updates.push({ date: isNaN(du) ? new Date(0) : du, status: su });
            }
        }
    }

    if (updates.length) {
        updates.sort((a, b) => b.date - a.date);
        const latest = updates[0].status;
        if (STATUS_MAP[latest]) return STATUS_MAP[latest];
    }

    // 3) Fallbacks
    if (item?.active === false) return { label: 'Indisponível', color: 'red' };
    if (ads.length === 0) return { label: 'Pausado', color: 'orange' };

    // se tem anúncios, mas não foi possível mapear status
    return { label: 'Pausado', color: 'orange' };
}


function formatBRL(n) {
    try { return n?.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) ?? '0,00'; }
    catch { return '0,00'; }
}

export default function MarketplaceTab({ produto, setProduto }) {
    const accessToken = window.localStorage.getItem("accessToken");
    const { data: config, error } = useConfigQuery();
    const [anuncios, setAnuncios] = useState();
    const [estoqueProduto, setEstoqueProduto] = useState(0);
    const [skuProduto, setSku] = useState("");
    const [statusProduto, setStatusProduto] = useState("");
    const [loading, setLoading] = useState(false);
    const [novoAnuncio, setNovoAnuncio] = useState(false);
    const [novoAnuncioTravado, setNovoAnuncioTravado] = useState(false);
    const [channels, setChannels] = useState([]);
    const API_BASE = 'https://apimarket.pedtech.com.br/v1';
    const [historicoMap, setHistoricoMap] = useState(new Map());
    const [selectedChannelId, setSelectedChannelId] = useState(null);
    const [anuncioSelecionado, setAnuncioSelecionado] = useState(null);


    const voltar = () => {
        setNovoAnuncio(false);
        fetchDetalhes();
        setAnuncioSelecionado(null);
    }

    const fetchDetalhes = async () => {
        try {
            setLoading(true);
            const resp = await axios.get(`https://apimarket.pedtech.com.br/v1/produtos/${produto.sku}/detalhes/${config.restaurante.cnpj}`, {
                headers: {
                    token: config.tokenMarketplace,
                },
                // signal: controller.signal,
            });

            setAnuncios(resp.data);


            const categoriasVinculadas = await axios.get(`https://apimarket.pedtech.com.br/v1/historico-associacao/${produto.categoria.id}/${config.restaurante.cnpj}`, {
                headers: {
                    token: config.tokenMarketplace,
                },
                //  signal: controller.signal,
            });


            console.log(categoriasVinculadas.data);
            const adsIdsSet = new Set(resp.data.ads.map((a) => String(a.saleschannelid)));

            // true se EXISTE algum canal que NÃO tem nenhum anúncio correspondente



            console.log(categoriasVinculadas.data);
            console.log(adsIdsSet);

            const existeCanalSemAnuncio = categoriasVinculadas.data.some((categoria) => {
                return !adsIdsSet.has(String(categoria.idSaleChannel));
            });

            console.log('existeCanalSemAnuncio:', existeCanalSemAnuncio);


            setNovoAnuncioTravado(!existeCanalSemAnuncio);


        } catch (err) {
            if (axios.isCancel(err)) return;
            console.error('Erro ao buscar detalhes do produto:', err);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        const controller = new AbortController();
        fetchDetalhes();
        return () => controller.abort();
    }, []);

    const fetchChannelsDaLoja = async () => {
        const url = `https://apimarket.pedtech.com.br/v1/saleschannelloja/${config.restaurante.cnpj}`;
        const headers = {
            token: config.tokenMarketplace,
        };
        const { data } = await axios.get(url, { headers });
        return data || [];
    }

    const handleNovo = () => {
        // Abra modal/drawer de criação aqui
        console.log('Novo anúncio');
        setNovoAnuncio(true);
    };

    const removerProdutoMkt = async () => {
        try {
            const headers = {
                token: config.tokenMarketplace,
                data: {},
            };
            const resp = await axios.delete(
                `https://apimarket.pedtech.com.br/v1/produtos/${produto.sku}/${config.restaurante.cnpj}`,
                { headers }
            );

            // aceita 200 ou 204 como sucesso
            if (resp.status == 200 || resp.status == 204) {

                if (produto.temMkt) {
                    const options = {
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + accessToken,
                        },
                    };
                    const respAttTemMkt = await axios.put(`https://techspdv-api-d3e739785e34.herokuapp.com/v1/restaurantes/a992b030-a5a5-4c85-9211-f5230501e8f7/produtos/atualizarMkt/${produto.id}/false`, {}, options);
                    if (respAttTemMkt.status === 200) {
                        setProduto(respAttTemMkt.data);
                    }

                    console.log(respAttTemMkt.data);
                    message.success('Produto removido com sucesso.');
                    voltar();
                }


            } else {
                message.warning(`Remoção retornou status ${resp.status}.`);
            }
        } catch (err) {
            console.error(err);
            message.error('Falha ao remover o produto.');
        } finally {
            // setDeletingId(null);
        }
    };

    // derive informações derivadas com efeito (sem side-effects no useMemo)
    useEffect(() => {
        if (!anuncios) return;
        setStatusProduto(deriveStatus(anuncios));
        const sku = anuncios.sku || anuncios.hubsku || anuncios.productId || '—';
        setSku(sku);
    }, [anuncios]);


    const S = (v) => (v == null ? '' : String(v));
    const toNumberOrZero = (v) => {
        const n = Number(v);
        return Number.isNaN(n) ? 0 : n;
    };

    const round2 = (v) => {
        const n = toNumberOrZero(v);
        return Number(Math.round(n * 100) / 100);
    };

    const formatCurrencyBR = (v) =>
        round2(v).toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });


    const fetchHistoricoAssociacao = async () => {
        const url = `${API_BASE}/historico-associacao/${produto?.categoria?.id}/${config.restaurante.cnpj}`;
        const headers = { token: config.tokenMarketplace };
        const { data } = await axios.get(url, { headers });

        const map = new Map();
        for (const h of (data || [])) {
            const ch = S(h.idSaleChannel);
            const nomeCat = S(h.nomeCategoriaSaleChannel);
            const cat = S(h.idCategoriaSaleChannel);
            if (!map.has(ch)) map.set(ch, new Set());
            if (cat) map.get(ch).add(cat);
            if (nomeCat) map.get(ch).add(nomeCat);
        }
        setHistoricoMap(map);
        console.log(map);
        return map;
    }


    useEffect(() => {
        (async () => {
            try {
                /* setLoading(true);
                 const hist = await fetchHistoricoAssociacao();
                 const canais = await fetchChannelsDaLoja();
 
 
                 // só canais com vínculo
                 const canaisComVinculo = (canais || []).filter((ch) => {
                     const chId = S(ch.salesChannelId);
                     return hist.has(chId) && hist.get(chId)?.size > 0;
                 });
                 setChannels(canaisComVinculo);
 
                 // resolve labels
                 for (const ch of canaisComVinculo) {
                     const chId = S(ch.salesChannelId);
                     const idsSet = hist.get(chId);
                     resolveLabelsForChannel(chId, idsSet);
                 }*/
            } catch (e) {
                console.error(e);
                message.error('Erro ao carregar dados dos canais');
            } finally {
                setLoading(false);
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [produto?.categoria?.id]);




    const buildPayload = () => {
        // Monta todas as imagens válidas
        const imagens = [];

        if (produto?.img1) {
            imagens.push(`https://api.pedtech.com.br/imagens/${produto.img1}`);
        }
        if (produto?.img2) {
            imagens.push(`https://api.pedtech.com.br/imagens/${produto.img2}`);
        }
        if (produto?.img3) {
            imagens.push(`https://api.pedtech.com.br/imagens/${produto.img3}`);
        }
        if (produto?.img4) {
            imagens.push(`https://api.pedtech.com.br/imagens/${produto.img4}`);
        }

        const ch = channels.find((c) => S(c.salesChannelId) === S(selectedChannelId));

        const basePrice = round2(produto?.preco ?? produto?.price ?? 0);

        // Canal selecionado
        const salesChannel = {

        };

        const salesChannels = [salesChannel];

        const payload = {
            productId: S(produto?.id || 'PRODUTO_SEM_ID'),
            productName: S(produto?.nome || produto?.name || ''),
            sku: S(produto?.sku || produto?.hubsku || produto?.codigo || ''),
            name: S(produto?.nome || produto?.name || ''),
            brand: S(produto?.marca || produto?.brandMkt || 'SEM MARCA'),
            description: S(produto?.descricao || produto?.description || ''),
            price: basePrice,
            stock: Number(produto?.quantidade_estoque ?? produto?.stock ?? 1),
            width: Number(produto?.width ?? produto?.largura ?? 1),
            height: Number(produto?.height ?? produto?.altura ?? 1),
            length: Number(produto?.length ?? produto?.comprimento ?? 1),
            weight: Number(produto?.weight ?? produto?.peso ?? 1),
            active: produto?.ativo != null ? Boolean(produto.ativo) : true,

            model: S(produto?.modelo || produto?.model || 'Padrão'),
            anatelCode: S(produto?.anatelCode || ''),

            customCategory: {
                alternativeId: S(produto?.categoria?.id || ''),
            },

            salesChannels,
            images: imagens,
            metafields: [
                {
                    key: 'cor',
                    value: 'preto',
                },
            ],
        };

        return payload;
    };

    const deletarAnuncio = async (id) => {
        const payload = buildPayload();
        console.log(`https://apimarket.pedtech.com.br/v1/produtos/excluirAnuncio/${id}/${config.restaurante.cnpj}`,);
        console.log(id);

        console.log(payload);

        const TOKEN = config.tokenMarketplace;
        const headers = { token: TOKEN }; // mantém seu esquema de header
        const CNPJ =  config.restaurante.cnpj;

        if (!id) {
            message.error('ID não informado.');
            return;
        }

        try {
            //setDeletingId(id);
            const resp = await axios.delete(
                `https://apimarket.pedtech.com.br/v1/produtos/excluirAnuncio/${id}/${CNPJ}`,
                {
                    data: payload,   // 👈 body vai aqui
                    headers: headers // ou só headers, se já for um objeto
                }
            );

            // aceita 200 ou 204 como sucesso
            if (resp.status === 200 || resp.status === 204) {
                await fetchDetalhes();
                message.success('Anúncio removido com sucesso.');
            } else {
                message.warning(`Remoção retornou status ${resp.status}.`);
            }
        } catch (err) {
            console.error(err);
            message.error('Falha ao remover o anúncio.');
        } finally {
            //setDeletingId(null);
        }
    }


    const cards = useMemo(() => {
        if (!anuncios) return null;
        console.log(produto);
        const status = deriveStatus(anuncios);

        const updated = anuncios.updatedAt
            ? new Date(anuncios.updatedAt).toLocaleString('pt-BR')
            : null;

        return (anuncios?.ads ?? []).map((anuncio, idx) => {
            console.log(anuncio);

            let img = '';
            if (anuncio.saleschannellogo != null) {
                img = anuncio.saleschannellogo;
            } else {
                img = `https://api.pedtech.com.br/imagens/mkt_img_1762369865`;
            }

            const canal = anuncio?.saleschannelname || '—';
            const statusDoAnuncio = anuncio?.saleChannelStatus || '—';
            const start = anuncio?.forsaledatestart
                ? new Date(anuncio.forsaledatestart).toLocaleDateString('pt-BR')
                : null;
            const end = anuncio?.forsaledatestend
                ? new Date(anuncio.forsaledatestend).toLocaleDateString('pt-BR')
                : null;

                console.log(anuncio);

            return (
                <Col key={anuncio.anuncio_id || `${anuncio.saleschannelid}-${idx}`}
                    xs={24} sm={12} md={8} lg={6}>
                    <Card
                        hoverable
                        style={styles.cardSquare}
                        cover={
                            <div style={styles.coverInfo}>
                                <img src={img} alt={anuncios.productName || anuncios.sku || 'produto'} style={styles.miniThumb} />
                                <div style={styles.coverText}>
                                    <Text type="secondary">{canal}</Text>
                                    <div style={styles.pillsRow}>
                                        <Tag color="blue">{`Canal: ${anuncio?.saleschannelid}`}</Tag>
                                        <Tag color={status.color}>{statusDoAnuncio}</Tag>
                                    </div>
                                </div>
                                <div style={{ marginRight: 10 }}>
                                    <Popconfirm
                                        title="Remover anúncio?"
                                        okText="Remover"
                                        cancelText="Cancelar"
                                        okButtonProps={{ danger: true }}
                                        onConfirm={(e) => {
                                            e?.stopPropagation?.();
                                            deletarAnuncio(anuncio?.saleschannelid, produto.sku);
                                        }}
                                        onCancel={(e) => e?.stopPropagation?.()}
                                    >
                                        <Button
                                            type="primary"
                                            size="small"
                                            danger
                                            icon={<DeleteOutlined />}
                                            // loading={deletingId === categoria?.id}
                                            onClick={(e) => e.stopPropagation()} // evita abrir o onClick do Card
                                        />
                                    </Popconfirm>
                                </div>
                            </div>
                        }
                        onClick={() => { setAnuncioSelecionado(anuncio); setNovoAnuncio(true); }}
                    >
                        <Space direction="vertical" size={6} style={{ width: '100%' }}>
                            <Text strong>
                                De: R$ {formatBRL(anuncio.price)} {start ? ` - ${start}` : ''}
                            </Text>
                            <Text strong>
                                Por: R$ {formatBRL((anuncio.forsaleprice != null ? anuncio.forsaleprice : anuncio.price))} {end ? ` - ${end}` : ''}
                            </Text>

                            <div style={styles.metaRow}>
                                {anuncios.model ? <Tag>{anuncios.model}</Tag> : null}
                                {(anuncios.width || anuncios.height || anuncios.length) ? (
                                    <Tag>{`${anuncios.width ?? '-'} x ${anuncios.height ?? '-'} x ${anuncios.length ?? '-'}`}</Tag>
                                ) : null}
                                {anuncios.weight ? <Tag>{`${anuncios.weight}g`}</Tag> : null}
                            </div>
                            {anuncio.saleChannelErro ? (
                                <Text type="secondary" style={{ fontSize: 12 }}>
                                    {anuncio.saleChannelErro}
                                </Text>
                            ) : null}



                            {anuncio.dataCriacao ? (
                                <Text type="secondary" style={{ fontSize: 12 }}>
                                    Criado em{' '}
                                    {new Date(anuncio.dataCriacao + 'Z').toLocaleString('pt-BR', {
                                        timeZone: 'America/Sao_Paulo',
                                        hour12: false
                                    })}
                                </Text>
                            ) : null}
                            {anuncio.updateDate ? (
                                <Text type="secondary" style={{ fontSize: 12 }}>
                                    Atualizado em{' '}
                                    {new Date(anuncio.updateDate + 'Z').toLocaleString('pt-BR', {
                                        timeZone: 'America/Sao_Paulo',
                                        hour12: false
                                    })}
                                </Text>
                            ) : null}
                        </Space>
                    </Card>
                </Col>
            );
        });
    }, [anuncios]);





    return (
        !novoAnuncio ?
            (<div>
                <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Title level={4} style={{ margin: 0 }}>Anúncios do Marketplace <Tag style={{
                        fontSize: 14,       // tamanho da fonte maior
                        padding: '4px 10px', // aumenta a área clicável/visual
                        lineHeight: '20px', // ajuda a centralizar verticalmente
                        borderRadius: 4,    // opcional: mais arredondado
                    }} color={anuncios?.stock > 0 ? 'green' : 'red'}>{`Estoque: ${anuncios?.stock || 0}`}</Tag><Tag style={{
                        fontSize: 14,       // tamanho da fonte maior
                        padding: '4px 10px', // aumenta a área clicável/visual
                        lineHeight: '20px', // ajuda a centralizar verticalmente
                        borderRadius: 4,    // opcional: mais arredondado
                    }} color={'blue'}>{`Canais: ${(anuncios?.ads?.length || 0)}`}</Tag> <Tag style={{
                        fontSize: 14,       // tamanho da fonte maior
                        padding: '4px 10px', // aumenta a área clicável/visual
                        lineHeight: '20px', // ajuda a centralizar verticalmente
                        borderRadius: 4,    // opcional: mais arredondado
                    }}>{`SKU: ${skuProduto}`}</Tag>
                        {anuncios?.updatedAt
                            ? `Atualização: ${new Date(anuncios?.updatedAt).toLocaleDateString('pt-BR')}`
                            : ''}
                    </Title>
                    <div style={{ display: 'flex', gap: 10 }}>


                        <Popconfirm
                            title="Remover Produto?"
                            okText="Remover"
                            cancelText="Cancelar"
                            okButtonProps={{ danger: true }}
                            onConfirm={removerProdutoMkt}
                            onCancel={(e) => e?.stopPropagation?.()}
                        >
                            <Button type="primary" style={{
                                backgroundColor: produto.temMkt ? 'red' : '#E5E5E5',
                                borderColor: produto.temMkt ? 'red' : '#E5E5E5',
                            }} icon={<DeleteOutlined />} disabled={!produto.temMkt} >
                                Remover Tudo
                            </Button>
                        </Popconfirm>


                        <Button type="primary" icon={<PlusOutlined />} onClick={handleNovo} disabled={novoAnuncioTravado || !produto.sku || (!produto.img1 && !produto.img2 && !produto.img3 && !produto.img4)} style={{ background: '#000', borderColor: '#000', color: '#ffffff' }}>
                            Novo Anúncio
                        </Button></div>
                </div>
                <Button type="primary" icon={<PlusOutlined />} onClick={() => { console.log(produto) }} style={{ background: '#000', borderColor: '#000', color: '#ffffff' }}>
                    Mostrar Produto
                </Button>
                {loading ? (
                    <Row gutter={[16, 16]}>
                        {Array.from({ length: 6 }).map((_, i) => (
                            <Col key={i} xs={24} sm={12} md={8} lg={6}>
                                <Card style={styles.cardSquare}>
                                    <Skeleton active avatar paragraph={{ rows: 3 }} />
                                </Card>
                            </Col>
                        ))}
                    </Row>
                ) : anuncios?.ads?.length == 0 ? (
                    <Empty description="Nenhum anúncio cadastrado" />
                ) : (
                    <Row gutter={[16, 16]}>{cards}</Row>
                )}
            </div>) : (anuncioSelecionado ? (
                <EditarAnuncioMkt
                    cnpj={config.restaurante.cnpj}
                    voltar={voltar}
                    produto={produto}
                    anuncioSelecionado={anuncioSelecionado}
                />
            ) : (
                <NovoAnuncioMkt
                    cnpj={config.restaurante.cnpj}
                    voltar={voltar}
                    produto={produto}
                    ads={anuncios?.ads || []}
                    setProduto={setProduto}
                />
            ))
    )
}

const styles = {
    cardSquare: {
        width: '100%',
        borderRadius: 12,
        overflow: 'hidden',
        aspectRatio: '1 / 1',
        display: 'flex',
        flexDirection: 'column',
    },
    thumbWrap: {
        width: '100%',
        aspectRatio: '1 / 1',
        overflow: 'hidden',
        background: '#f2f2f2',
    },
    thumbImg: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        display: 'block',
    },


    cardSquare: {
        width: '100%',
        borderRadius: 12,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        // removi o aspectRatio para não forçar quadrado rígido,
        // agora o conteúdo (cover informativo) define a altura
    },

    coverInfo: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: 0,
        position: 'relative',
        background: '#fafafa',
        borderBottom: '1px solid #f0f0f0',
    },

    miniThumb: {
        width: 56,
        height: 56,
        objectFit: 'cover',
        borderRadius: 8,
        flex: '0 0 auto',
        background: '#f2f2f2',
    },

    coverText: {
        minWidth: 0, // permite ellipsis funcionar
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
    },

    pillsRow: {
        display: 'flex',
        gap: 6,
        flexWrap: 'wrap',
        marginTop: 2,
    },

    statusPill: {
        position: 'absolute',
        right: 12,
        top: 12,
    },

    metaRow: {
        display: 'flex',
        gap: 6,
        flexWrap: 'wrap',
    },

};

